<template>
  <div>
    <b-modal id="mass-assignments-modal" no-close-on-backdrop
             :modal-class="`adp-big-modal adp-big-modal__no_footer`"
             :body-class="`adp-big-modal-body`" :header-class="`adp-big-modal-header`" @show="onShow">

      <template #modal-header>
        <button class="btn adp-btn" @click="checkAssign">
          {{ $t('catalog.assign') }}
        </button>

        <button type="button" class="close adp-close" data-dismiss="modal" aria-label="Close" @click="close">
          <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
        </button>
      </template>
      <template #modal-header-close>

      </template>
      <template>
        <div class="mass-assignments-modal-back" @click="close">
          <img class="mass-assignments-modal-back--icon" src="/images/arrow_back.svg" alt="">
        </div>
        <div class="mass-assignments-modal-search">
          <template>
            <div class="d-flex">
              <div class="custom-control custom-checkbox menu-label mass-assignments-modal-search--checkbox"
                   :class="{'partial-checked': partialChecked}" @click="toggleCheckedSearch">
                <input type="checkbox" class="custom-control-input" v-model="allChecked" value="1" checked>
                <span class="custom-control-label" style="cursor: pointer">{{ '' }}</span>
              </div>
              <div class="d-flex flex-column mass-assignments-modal-search--search">
                <span class="adp-th">{{ $t('catalog.assign_search_group') }}</span>
                <div class="d-flex">
                  <input type="text" class="adp-input adp-input__catalog adp-input-search" v-model="searchInput"
                         @keydown.enter="searchItems">
                  <button class="btn adp-btn ml-2" @click="searchItems">{{$t("voc.mentor_field_filter_button")}}</button>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="mass-assignments-modal-block">
          <div class="adp-big-modal-row">
            <structure-tree ref='structureTree'
                            v-if="checkedItems[company.id]"
                            v-for="(company, key) in companies"
                            :key="company.id"
                            :search="search"
                            :parent="company"
                            :label="company.name"
                            :open="false"
                            :preset-values="{}"
                            :parentChecked="checkedItems[company.id].checked"
                            :parentShowMobile="checkedItems[company.id].showMobile"
                            :parentLevel="0"
                            :checkedItems="checkedItems[company.id]"
                            @toggleMobile="toggleMobile"
                            @updateItemsSearch="updateItemsSearch"
                            @updateItemsChecked="updateItemsChecked">
            </structure-tree>
          </div>
          <div class="mass-assignments-modal-block--assign">
            <button class="btn adp-btn" @click="checkAssign">{{ $t('catalog.assign') }}</button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal id="alert-assignments-modal" hide-header-close
             :modal-class="`adp-modal`"
             :header-class="`adp-modal-header mb-0 pb-2`"
             :body-class="`adp-modal-body`"
             :footer-class="`adp-modal-footer d-flex justify-content-center align-self-end p-2 m-2`"
             @close="setDeadlines">
      <template #modal-title>
        <div class="d-flex">
          <span class="modal-title adp-h2 adp-h2__modal" style="font-size: 22px; color: #404246">{{ $t('modal.already_been_added')}}</span>
          <span class="rounded ml-3 px-1" style="background-color: #F5F5F5; color: #57606F;">{{ userAssignmentsTotal }}</span>
        </div>
      </template>
      <template>
        <div v-for="(activityUsers, activityKey) in sortedAssignments">
          <p class="mb-2 mt-3" style="font-size: 16px;">
            {{ $t('catalog.mass_assign_alert_1') }} "{{ activities[activityKey].name }}" {{ $t('catalog.mass_assign_alert_2') }}:
          </p>
          <p v-for="user, index in activityUsers" class="mb-1">
            {{ index + 1 }}. {{ user.surname }} {{ user.name }} {{ user.patronymic }} {{ user.pernumber }} {{ user.fired ? ' ('+$t('modal.idp_export_fired_status_fired')+')' : '' }}
          </p>
        </div>
      </template>
      <template #modal-footer>
        <button class="btn adp-btn adp-btn__large"
                @click="$bvModal.hide('alert-assignments-modal'); setDeadlines();">
          {{ $t('modal.next')}}
        </button>
      </template>
    </b-modal>

    <div v-for="(activity, i) in Object.values(activities)" :key="i"
         v-if="Object.keys(activities).length && activity.pernumbers && activity.pernumbers.length">
      <mass-deadlines-modal :activity="activity" :activity-index="i" :employee-pernumbers="activity.pernumbers"
                            @assignments-list-open="openAssignmentsListModal"/>
    </div>

    <assignments-list-modal :user-assignments="assignmentsListData"/>
  </div>

</template>

<script>

import StructureTree from "../StructureTree";
import ActivityTypeSelect from "../ActivityTypeSelect";
import MassDeadlineModal from "./MassDeadlineModal";
import DeadlineModal from "./DeadlineModal";
import AssignmentsListModal from "./AssignmentsListModal.vue";
import api from "../../api";

export default {
  name: "MassAssignmentModal",
  components: {
    StructureTree,
    ActivityTypeSelect,
    'mass-deadlines-modal': MassDeadlineModal,
    'deadline-modal': DeadlineModal,
    'assignments-list-modal': AssignmentsListModal
  },
  props: {
    learningActivityIds: {
      type: Object,
      required: true,
    },
    learningActivity: {
      type: Object,
      required: false,
    },
  },
  data: function () {
    return {
      userAssignments: {},
      userAssignmentsTotal: 0,
      sortedAssignments: {},
      search: '',
      searchInput: '',
      noUsersError: false,
      companies: {},
      partialChecked: false,
      allChecked: false,
      checkedItems: {},
      activities: {},
      allUsers: [],
      checkedPernumbers: new Set(),
      assignmentsListData: {},
    }
  },
  created() {
    if(this.learningActivity.activityId) {
      this.activities = {};
      this.activities[this.learningActivity.activityId] = this.learningActivity;
    } else {
      this.activities = this.learningActivityIds;
    }

    axios.get(window.IDP.role + '/structure').then(response => {
      if (response.data.departments && Object.keys(response.data.departments).length) {
        this.companies = Object.assign({}, response.data.departments);
      } else {
        this.noUsersError = true;
      }

      for (let [key, value] of Object.entries(this.companies)) {
        let checked = false;
        let changed = false;

        this.checkedItems[value.id] = {
          partialChecked: false,
          items: {},
          id: value.id,
          checked: checked,
          changed: changed,
          inSearch: false,
          itemsSearch: false,
          showMobile: true,
          itemsOpenMobile: false,
          type: value.type,
          name: value.name,
          parent_type: value.parent_type,
          parent_id: value.parent_id,
          department_id: value.department_id,
        }
      }
    });
  },
  watch: {
    search: function () {
      this.noUsersError = false;
    },
    learningActivityIds() {
      this.sortedAssignments = {};
      this.userAssignmentsTotal = 0;
      this.activities = this.learningActivityIds;
    },
    learningActivity() {
      this.sortedAssignments = {};
      this.userAssignmentsTotal = 0;
      this.activities = {};

      if(Object.keys(this.learningActivity).length) {
        this.activities[this.learningActivity.activityId] = this.learningActivity;
      } else {
        this.activities = this.learningActivityIds;
      }
    }
  },
  methods: {
    onShow() {
      this.search = '';
      this.searchInput = '';
      this.allChecked = false;
      this.partialChecked = false;
    },
    searchItems() {
      if (this.search === this.searchInput) {
        this.$refs['structureTree'].forEach((e) => e.reopenSearchedLeafs());
      }
      this.search = this.searchInput;
    },
    toggleCheckedSearch() {
      this.allChecked = !this.allChecked;

      _.each(this.checkedItems, (item) => {
        item.checked = this.allChecked;
      });
    },

    updateItemsSearch() {

    },

    toggleMobile(id, open) {
      this.partialChecked =
      _.each(this.checkedItems, (item) => {
        if(id !== item.id) {
          item.showMobile = open;
        }
      });
      this.checkedItems = Object.assign({}, this.checkedItems);
    },

    close() {
      this.$bvModal.hide('mass-assignments-modal');
      $('.adp-navbar').removeClass('adp-navbar-fixed');
    },

    updateItemsChecked() {
      const length = Object.keys(this.checkedItems).length;

      const checkedItems = Object.values(this.checkedItems).filter(function (item) {
        return item.checked;
      });

      const partialCheckedItems = Object.values(this.checkedItems).filter(function (item) {
        return item.partialChecked;
      });

      this.partialChecked = (checkedItems.length && checkedItems.length !== length) || partialCheckedItems.length;

      if (checkedItems.length && checkedItems.length === length) this.allChecked = true;
      if (!checkedItems.length && !partialCheckedItems.length) this.allChecked = false;
    },

    checkAssign() {
      this.checkedPernumbers = new Set();
      this.getCheckedItems(this.checkedItems);

      if(![...this.checkedPernumbers].length) {
        return;
      }

      Object.keys(this.activities).forEach(activity => {
        this.activities[activity].pernumbers = new Set(this.checkedPernumbers);
      });

      axios.post(window.IDP.role + '/structure/assignments', {
        users: [...this.checkedPernumbers],
        activities: this.activities
      }).then(response => {
        if (Object.keys(response.data.users).length) {
          this.userAssignments = response.data.users;

          this.sortedAssignments = {};
          for (let activityKey in this.userAssignments) {
            this.sortedAssignments[activityKey] = [];
            for (let userKey in this.userAssignments[activityKey]) {
              let user = this.userAssignments[activityKey][userKey];
              if (user.fired === 1) {
                this.sortedAssignments[activityKey].unshift(user);
              } else {
                this.sortedAssignments[activityKey].push(user);
              }
            }
          }
          
          this.userAssignmentsTotal = 0;
          for (let key in this.userAssignments) {
            this.userAssignmentsTotal += Object.keys(this.userAssignments[key]).length;
          }

          Object.keys(response.data.users).forEach(activuty => {
            Object.keys(response.data.users[activuty]).forEach(pernumber => {
              if (this.activities[activuty].pernumbers.has(Number(pernumber))) {
                this.activities[activuty].pernumbers.delete(Number(pernumber));
              }
            })
          })

          Object.keys(this.activities).forEach(activity => {
            this.activities[activity].pernumbers = [...this.activities[activity].pernumbers];
          });

          this.$bvModal.show('alert-assignments-modal');
        } else {
          Object.keys(this.activities).forEach(activity => {
            this.activities[activity].pernumbers = [...this.activities[activity].pernumbers];
          });
          this.setDeadlines();
        }
      });
    },

    async setDeadlines() {
      this.activities = _.cloneDeep(this.activities);
      await this.updateActivitiesData();
      this.$bvModal.show('mass-deadlines-modal');
    },

    updateActivitiesData() {
      Object.values(this.activities).forEach(async (activity) => {
        const res = await api.getLearningActivity(activity.activityType, activity.activityId);
        const activityData = res.data;
        activity.start_at = activityData.start_at;
        activity.end_at = activityData.end_at;
      })
    },

    assign(checked) {
      axios.put(window.IDP.role + '/structure/assignments', {
        users: checked,
        activities: this.activities
      }).then(response => {
        this.$bvModal.hide('mass-assignments-modal');
        $('.adp-navbar').removeClass('adp-navbar-fixed');
      });
    },

    getCheckedItems(items) {
      Object.keys(items).forEach(key => {
        if (items[key].type !== 'user' && (items[key].partialChecked || items[key].checked)) {
          this.getCheckedItems(items[key].items);
        }
        if (items[key].type === 'user' && items[key].checked) {
          this.checkedPernumbers.add(Number(items[key].id));
        }
      });
    },
    openAssignmentsListModal() {
      this.assignmentsListData = {};
      Object.values(this.activities).forEach(item => {
        item.users = [...item.pernumbers].map(p => this.allUsers.find(u => u.pernumber === p));
        this.assignmentsListData[item.activityId] = item;
      });
      this.$bvModal.show('assignments-list-modal');
    }
  },
  async mounted() {
    const allUsersRes = await axios.get('/search?withFired=1');
    this.allUsers = allUsersRes.data;
  }
}
</script>

<style>
.adp-filter-input--no-result {
  padding-left: 24px;
  margin-top: 20px;
  font-size: 16px;
}

.notifications-error {
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 25px;
}
</style>
